import { HIDE_RESULT, SHOW_RESULT } from '../Actions/ModalResult.action';

const defaultState = {
    isEnabled: true,
    isVisible: false
};

export const modalResult = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case HIDE_RESULT:
            return {
                ...state,
                isVisible: false,
            };
        case SHOW_RESULT:
            return {
                ...state,
                text: payload.text,
                icon: payload.icon,
                success: payload.success,
                isVisible: true,
            };
        default:
            return {
                ...state,
                isVisible: false,
            };
    }
};